import styled from "styled-components";
import { colors2, UI_CAPTION, Divider } from "oolib";

export const StyledSidebarStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledPanel = styled.section`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  padding: 16px;
  display: grid;
  gap: 12px;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 160px;
  border: 1px solid ${colors2.grey20};
  border-radius: 8px;
  padding: 12px;
  font-family: monospace;
  font-size: 12px;
  resize: vertical;
`;

export const StyledLayoutWrapper = styled.div`
  background: ${colors2.grey5};
  min-height: calc(100vh - 120px);
  padding: 24px;
  box-sizing: border-box;
  /* width: 400px; */
`;

export const StyledContentGrid = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
  background: #fff;
  padding: 1rem;
  border-radius: 12px;
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledDetailList = styled.div`
  display: grid;
  gap: 4px;
  padding: 0 4px;
`;

export const StyledTemplateList = styled.div`
  display: grid;
  gap: 8px;
`;

export const StyledFieldGrid = styled.div`
  display: grid;
  gap: 12px;
`;

export const StyledStageContent = styled.div`
  padding: 0 24px 16px;
  border: 1px solid ${colors2.grey10};
`;

export const StyledJsonWrapper = styled.div`
  border: 1px solid ${colors2.grey10};
  border-radius: 8px;
  padding: 12px;
  background: #fff;
`;

export const StyledDescription = styled(UI_CAPTION)`
  color: ${colors2.grey60};
`;

export const StyledDividerLarge = styled(Divider)`
  margin: 12px 0;
`;

export const StyledDividerMedium = styled(Divider)`
  margin: 8px 0;
`;

export const StyledFeedback = styled(UI_CAPTION)`
  color: ${({ $variant }) => ($variant === "error" ? "#D92D20" : "#027A48")};
`;
